export default __webpack_public_path__ + "static/media/fw-lily-er-Rose Gold.6c34cbe9.mp4";